var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColorModeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_20px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 2C6.544 2 5.176 2.4 4 3.08C6.4 4.464 8 7.04 8 10C8 12.96 6.4 15.536 4 16.92C5.176 17.6 6.544 18 8 18C10.1217 18 12.1566 17.1571 13.6569 15.6569C15.1571 14.1566 16 12.1217 16 10C16 8.94943 15.7931 7.90914 15.391 6.93853C14.989 5.96793 14.3997 5.08601 13.6569 4.34315C12.914 3.60028 12.0321 3.011 11.0615 2.60896C10.0909 2.20693 9.05058 2 8 2Z",
    fill: "#CCCFD1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorModeDark);
export default __webpack_public_path__ + "static/media/icon-color-mode-dark.18d36e3fcc94533de43053784aa99bdf.svg";
export { ForwardRef as ReactComponent };